import $ from 'jquery';
import { faro } from '@gate31/faro/src';
import { stringify } from '@gate31/core/src/libs/query-string';
import { subscriptionsItem } from '@gate31/touch/components/edit-subscriptions/edit-subscription-page-form/edit-subscription-page-form';
import { Gate31ApiV2 } from './gate31-api';

export const HOST_MINDBOX = 'https://api.mindbox.ru/v3/operations';

interface params {
    [key: string]: string;
}
interface headers {
    'Content-Type'?: string;
    Authorization?: string;
}
// eslint-disable-next-line

export interface Subscriptions {
    brand: 'gate31';
    pointOfContact: 'Email';
    topic?: string;
    isSubscribed?: string;
}
interface CustomerSubscribe {
    email: string;
    subscriptions: Subscriptions[];
}

interface dataForm {
    email: string;
    fullName: string;
    mobilePhone: string;
    isSubscribed: string;
}

interface SubscribeBody {
    customer: CustomerSubscribe;
}
export interface serCartBody {
    productList: {
        product: {
            ids: {
                gate31: number;
            };
        };
        count: number;
        pricePerItem: number;
    }[];
}

export interface editByEmailBody {
    customer: {
        email: string;
        subscriptions: Array<subscriptionsItem>;
    };
}

class MindBoxApiError extends Error {
    name = 'MindBoxApiError';
}

export class MindboxApi {
    static headers = {
        'Content-Type': 'application/json'
    }
    static commonGetParams = {
        endpointId: 'gate31',
        operation: 'subscribed'
    }

    static getDeviceUUID() {
        const deviceUUID = $ && $.cookie ? $.cookie('mindboxDeviceUUID') : null;

        if (deviceUUID) {
            return deviceUUID;
        }

        return null;
    }

    static subscribe(body: SubscribeBody, params: params | null, headers: headers | null) {
        return MindboxApi.send(body, params, headers);
    }

    static editByEmail(body: editByEmailBody) {
        const uuid = MindboxApi.getDeviceUUID();

        if (! uuid) return Promise.resolve();

        return Gate31ApiV2.mindboxUpdateSubsByEmail({ deviceUUID: uuid, email: body.customer.email, subscriptions: body.customer.subscriptions });
    }

    static editByTicket(body: {
        customer: {
            authenticationTicket: string;
            subscriptions: Array<subscriptionsItem>;
        };
    }) {
        const uuid = MindboxApi.getDeviceUUID();

        if (! uuid) return Promise.resolve();

        return Gate31ApiV2.mindboxUpdateSubsByTicket({ authenticationTicket: body.customer.authenticationTicket, subscriptions: body.customer.subscriptions, deviceUUID: uuid });
    }

    static editProfile() {
        const uuid = MindboxApi.getDeviceUUID();

        if (! uuid) return Promise.resolve();

        $.getJSON('/client_account/contacts.json', data => {
            const i = {
                customer: {
                    email: String($('#client_email').val()),
                    fullName: String($('#client_name').val()),
                    mobilePhone: String($('#client_phone').val()),
                    ids: {
                        siteid: data.client.id
                    },
                    subscriptions: [
                        {
                            brand: 'gate31',
                            pointOfContact: 'Email',
                            isSubscribed: String($('#client_subscribe').is(':checked'))
                        }
                    ]
                },
                deviceUUID: uuid
            };

            return Gate31ApiV2.mindboxEditProfile(i);
        });
    }

    static setFavorite(body: serCartBody) {
        if (! MindboxApi.getDeviceUUID()) {
            return;
        }

        const params = { operation: 'setfavorites' };

        return MindboxApi.send(body, params, null)
            .then(data => data)
            .catch(error => {
                faro.api.pushError(error, {
                    context: {
                        section: `MindBoxApi method setfavorites is ERROR - ${error}`
                    }
                });

                return;
            });
    }

    static signup(dataForm: dataForm) {
        const uuid = MindboxApi.getDeviceUUID();

        if (! uuid) return Promise.resolve();

        const body = {
            customer: {
                email: dataForm.email,
                fullName: dataForm.fullName,
                mobilePhone: dataForm.mobilePhone,
                subscriptions: [
                    {
                        isSubscribed: dataForm.isSubscribed
                    }
                ]
            },
            deviceUUID: uuid
        };

        return Gate31ApiV2.mindboxSignup(body);
    }

    static setCart(body: serCartBody) {
        if (! MindboxApi.getDeviceUUID()) {
            return Promise.resolve();
        }

        const params = { operation: 'setcart' };

        MindboxApi.send(body, params, null)
            .then(data => data)
            .catch(error => {
                faro.api.pushError(error, {
                    context: {
                        section: `MindBoxApi method setCart is ERROR - ${error}`
                    }
                });

                return;
            });
    }

    static categoryView(collectionId: number) {
        if (! MindboxApi.getDeviceUUID()) {
            return Promise.resolve();
        }

        const params = { operation: 'categoryview' };
        const body = {
            viewProductCategory: {
                productCategory: {
                    ids: {
                        gate31: collectionId
                    }
                }
            }
        };

        MindboxApi.send(body, params, null)
            .then(data => data)
            .catch(error => {
                faro.api.pushError(error, {
                    context: {
                        section: 'CategoryView'
                    }
                });

                return;
            });
    }

    static productView(productId: number) {
        if (! MindboxApi.getDeviceUUID()) {
            return Promise.resolve();
        }

        const params = { operation: 'productview' };
        const body = {
            viewProduct: {
                product: {
                    ids: {
                        gate31: productId
                    }
                }
            }
        };

        MindboxApi.send(body, params, null)
            .then(data => data)
            .catch(error => {
                faro.api.pushError(error, {
                    context: {
                        section: `MindBoxApi method productView is ERROR - ${error}`
                    }
                });

                return;
            });
    }

    static addViewed(productId: number, productPrice: string) {
        if (! MindboxApi.getDeviceUUID()) {
            return Promise.resolve();
        }

        const params = { operation: 'addviewed' };
        const body = {
            addProductToList: {
                product: {
                    ids: {
                        gate31: productId
                    }
                },
                pricePerItem: productPrice
            }
        };

        MindboxApi.send(body, params, null)
            .then(data => data)
            .catch(error => {
                faro.api.pushError(error, {
                    context: {
                        section: `MindBoxApi method addViewed is ERROR - ${error}`
                    }
                });

                return;
            });
    }

    static getUserSubscribeListByTicket(ticket: string) {
        const uuid = MindboxApi.getDeviceUUID();

        if (! uuid) return Promise.resolve();

        return Gate31ApiV2.mindboxGetUserSubscribeListByTicket({ deviceUUID: uuid, ticket });
    }

    static getUserSubscribeList(email: string) {
        const uuid = MindboxApi.getDeviceUUID();

        if (! uuid) return Promise.resolve();

        return Gate31ApiV2.mindboxGetUserSubscribeList({ deviceUUID: uuid, email });
    }

    static send(body: Record<string, any>, params: params | null, headers: headers | null, syncType = 'async') {
        const url = `${HOST_MINDBOX}/${syncType}?${stringify({
            ...MindboxApi.commonGetParams,
            ...params,
            deviceUUID: MindboxApi.getDeviceUUID()
        }, null)}`;

        return fetch(url, {
            method: 'POST',
            headers: { ...headers, ...MindboxApi.headers },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(response => {
                if (! response.status || response.status !== 'Success') {
                    throw new Error(JSON.stringify(response));
                }

                return response;
            })
            .catch((error: Error) => {
                throw new MindBoxApiError(error.message);
            });
    }
}
